import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaTimes } from 'react-icons/fa';

import Filter from '../../filter/FilterPannel';
import Const from '../../../util/Constants';

class ConditionNumber extends React.Component {

  onConditionChanged = condition => {
    let filter = { ...this.props.filter };
    filter = { ...filter, condition, andor: false };
    this.props.onFilterChanged(this.props.index, filter);
  }

  onChanged = (source, number) => {
    let filter = { ...this.props.filter };
    let value = '';
    
    const from = filter.from;
    const to = filter.to;
    if(source === 'from' && number !== null && to !== null) {
      value = `${number}${Const.Opt}${to}`;
    } else if(source === 'from' && number !== null && to === null) {
      value = `${number}${Const.Opt}`;
    } else if(source === 'from' && number === null && to !== null) {
      value = `${number}${Const.Opt}${to}`;
    } else if(source === 'to' && from !== null && number !== null) {
      value = `${from}${Const.Opt}${number}`;
    } else if(source === 'to' && from !== null && number === null) {
      value = `${from}${Const.Opt}`;
    } else if(source === 'to' && from === null && number !== null) {
      value = `${Const.Opt}${number}`;
    }

    if(source === 'from') {
      filter = { ...filter, value, from: number };
    } else { 
      filter = { ...filter, value, to: number };
    }
    this.props.onFilterChanged(this.props.index, filter);
  }

  render() {
    const i = this.props.index;
    const filter = this.props.filter;

    return (
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        {filter.field.label}
        
        <div className="condition-select col-md-3">
          <Select value={filter.condition} 
            onChange={ selected => this.onConditionChanged(selected) }
            options={filter.conditions} isSearchable={true} isClearable={true} />
        </div>

        <div className="condition-select col-md-8 value-float">
          { filter.condition && (filter.condition.value === Filter.In || filter.condition.value === Filter.NotIn || filter.condition.value === Filter.StartWith)
            ? <FormControl type="number" placeholder="From" value={filter.from} onChange={event => this.onChanged('from', event.target.value)} />
            : null
          }
          { filter.condition && (filter.condition.value === Filter.In || filter.condition.value === Filter.NotIn || filter.condition.value === Filter.EndsWith)
            ? <FormControl type="number" placeholder="To" value={filter.from} onChange={event => this.onChanged('to', event.target.value)} />
            : null
          }
          <Button variant="danger" onClick={() => this.props.onDelete(i)}><FaTimes /></Button>
        </div>
      </div>
    );
  }
}
export default ConditionNumber;